import React from "react"
import FieldFormElementView, {FieldFormElementViewProps} from "../../../../render/form-elemnent-view"
import {FieldType} from "../../../../field-type"
import FieldsFactory from "../../../../fields-factory"
import {ReportDate} from "../model/model"

const debug = false
// const debug = "FieldAgileReportDate_FormElement"

export default class FieldAgileReportDate_FormElementView extends React.Component<FieldFormElementViewProps, any> {

    constructor(props: FieldFormElementViewProps) {
        super(props);
    }

    onPresetChange = (start:number) => {
        const reportDate : ReportDate = this.props.field.getViewValue(this.props.model)

        const newReportDate = new ReportDate(reportDate).clone()
        newReportDate.lastDays  = start
        newReportDate.startDate = null
        newReportDate.endDate   = null

        debug && console.log(debug, "onPresetChange",reportDate)

        // @ts-ignore
        this.props.onChange(newReportDate)
        // this.onChange(newReportDate)

        this.forceUpdate()
    }

    onDateRangeChange = (dateRange: any) => {

        const reportDate : ReportDate = this.props.field.getViewValue(this.props.model)

        const newReportDate      = new ReportDate(reportDate).clone()
        newReportDate.lastDays   = null
        newReportDate.startDate  = dateRange.start
        newReportDate.endDate    = dateRange.end

        debug && console.log(debug, "onDateRangeChange",dateRange)

        // @ts-ignore
        this.props.onChange(newReportDate)
        // this.onChange(newReportDate)

        this.forceUpdate()
    }

    render(): JSX.Element | false {

        const reportDate : ReportDate = this.props.field.getViewValue(this.props.model)

        debug && console.log(debug, "render reportDate", reportDate)

        const presetRangeSelector = FieldsFactory.get({
            fieldId             : 'lastDays',
            type                : FieldType.DROPDOWN,
            label               : 'Date range',
            options             : this.props.field.options,
            noValueOption       : false,
            showMenuMore        : false
        })

        const dateRangeSelector = FieldsFactory.get({
            fieldId         : 'dateRange',
            type            : FieldType.DATE_RANGE,
            maxDate         : momentDate(),
            clearButton     : false,
        })

        const dateRangeModel = !reportDate.lastDays && reportDate.startDate && reportDate.endDate ?
            {dateRange: {start: reportDate.startDate, end: reportDate.endDate}}
            :
            null

        debug && console.log(debug, "render dateRange", dateRangeModel)

        return (
            <div className={Classes("flex-column-left-top", this.props.className)}>
                {presetRangeSelector &&
                    <FieldFormElementView className =   "w-100-percent"
                                          disabled  =   {this.props.disabled}
                                          field     =   {presetRangeSelector}
                                          model     =   {reportDate}
                                          onChange  =   {this.onPresetChange}/>}

                {dateRangeSelector && !reportDate.lastDays &&
                    <FieldFormElementView className =   "w-100-percent max-w-100-percent m-t-15"
                                          disabled  =   {this.props.disabled}
                                          field     =   {dateRangeSelector}
                                          model     =   {dateRangeModel}
                                          onChange  =   {this.onDateRangeChange}/>}
            </div>
        )
    }
}
